import { render, staticRenderFns } from "./AccountSettingSMTPSettings.vue?vue&type=template&id=2a472fca&"
import script from "./AccountSettingSMTPSettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSMTPSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports